import React from 'react';
import Button from 'components/Button';

import './styles.css';

const TodayTomorrowButtons = ({
  isToday,
  isTomorrow,
  showTodays,
  showTomorrows
}) => (
  <div className="TodayTomorrowButtons">
    <Button blue={isToday} white={!isToday} onClick={showTodays}>
      Today
    </Button>
    <Button blue={isTomorrow} white={!isTomorrow} onClick={showTomorrows}>
      Tomorrow
    </Button>
  </div>
);

export default TodayTomorrowButtons;
